import RuntimeUtils from 'src/common/js/runtimeUtils'
import { $get, $post, $put, $delete } from 'src/utils/httpUtil'

const BASE_URL = RuntimeUtils.instance.getConsoleServiceHostname()
const CONSOLE_SERVE = '/bimserver/console/v3'
/*
 * 查询模型组装列表；
 * isLod 表示是否进行LOD组装列表查询；
 * isLod 默认为false;
 * */
export const tempGetModelAssembleList = () => {
  return new Promise((resolve, reject) => {
    const lodUrl = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/modelpackage?type=1`
    $get(lodUrl)
      .then((lodRes) => {
        resolve(lodRes.data)
      })
      .catch(reject)
  })
}
export const getModelAssembleList = () => {
  return new Promise((resolve, reject) => {
    const obvUrl = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/modelpackage`
    const lodUrl = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/modelpackage?type=1`
    let obvData = [],
      lodData = [],
      allData = []
    $get(obvUrl)
      .then((obvRes) => {
        obvData = obvRes.data.map((ele) => ({
          id: ele.id,
          num: ele.num,
          packageName: ele.packageName,
          startTime: ele.startTime,
          status: ele.status,
          convertType: 'obv',
        }))
        $get(lodUrl).then((lodRes) => {
          lodData = lodRes.data.map((ele) => ({
            id: ele.id,
            num: ele.num,
            packageName: ele.packageName,
            startTime: ele.startTime,
            status: ele.status,
            convertType: 'lod',
          }))
          allData = obvData.concat(lodData)
          resolve(allData)
        })
      })
      .catch(reject)
  })
}
/*
 * 新增模型组装列表
 * type = 1 时，表示进行LOD组装
 * */
export const addModelAssembleRequest = (body) => {
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/modelpackage`
    $post(url, body)
      .then(() => {
        resolve()
      })
      .catch(reject)
  })
}

// 删除模型组装列表
export const deleteModelAssemble = (id) => {
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/modelpackage?id=${id}`
    $delete(url)
      .then((res) => {
        resolve(res)
      })
      .catch(reject)
  })
}

// 查询模型组装参数列表
export const getModelAssembleView = (id) => {
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/modelparams?packageId=${id}`
    $get(url)
      .then((res) => {
        resolve(res)
      })
      .catch(reject)
  })
}

// 修改模型组装列表
export const editModelAssembleView = (name, body) => {
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/modelparams?packageName=${name}`
    $put(url, body)
      .then((res) => {
        resolve(res.data)
      })
      .catch(reject)
  })
}



// WEBPACK FOOTER //
// ./src/utils/modelAssemble.js